import * as React from 'react';
import { IconChevronRightSmall16, LinkButton, UIText1 } from '@cian/ui-kit';

import * as styles from './BookingExistsContent.css';
import { NBSP } from '../../constants/symbols';

interface IBookingExistsContentProps {
  href: string;
}

export const BookingExistsContent: React.FC<IBookingExistsContentProps> = ({ href }) => {
  return (
    <div className={styles['container']}>
      <UIText1>
        Если{NBSP}есть{NBSP}вопросы — задайте{NBSP}их{NBSP}специалисту в{NBSP}чате
      </UIText1>
      <LinkButton
        fullWidth
        size="M"
        target="_blank"
        href={href}
        afterIcon={<IconChevronRightSmall16 color="current_color" />}
      >
        К заявке
      </LinkButton>
    </div>
  );
};
